import { createContext as t, useContext as e } from "react";
const o = t({
  isOpen: !1,
  onClose: () => {
  }
}), n = () => e(o);
export {
  o as B,
  n as u
};
